import { render, staticRenderFns } from "./actualite.vue?vue&type=template&id=dbc27da4"
import script from "./actualite.vue?vue&type=script&lang=js"
export * from "./actualite.vue?vue&type=script&lang=js"
import style0 from "./actualite.vue?vue&type=style&index=0&id=dbc27da4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports